import { useCancellation } from 'hooks/cancellation/useCancellation';

import { Marked, Title } from '../../../components/Title/Title';
import { InfoBlock } from './InfoBlock';

import s1 from './CancellationPolicySection.module.css';
import s from './InfoBlock.module.css';
import s2 from 'themes/playful/components/PlayfulLayout.module.css';

export const CancellationPolicySection = () => {
  const { cancellationPolicyText } = useCancellation();

  return (
    <InfoBlock className={s2.content}>
      <Title>
        Cancellation{' '}
        <span className={s1.newline}>
          <Marked>Policy</Marked>
        </span>
      </Title>
      <p className={`${s.content} ${s1.content}`}>{cancellationPolicyText}</p>
    </InfoBlock>
  );
};
